/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "7.3.0";
